import Background from "@/module/sketch/background";
import Eye from "@/module/sketch/eye";
import Util from "@/module/Utils/Util";
//
const defaultAnimation = (p) => {
  const background = p.createGraphics(
    window.innerWidth / 2,
    window.innerHeight / 2,
    p.WEBGL
  );
  let bg;
  let frameRateVal = 30;
  const eye = new Eye(p, 0, { pc: 0, sp: 0 }, { pc: 0, sp: 0 }, frameRateVal);
  let shaders;
  let canvas;

  p.preload = () => {
    // bg.preload();
    shaders = p.loadShader(
      `${process.env.GATSBY_ASSETS_PATH}shader/default.vert`,
      `${process.env.GATSBY_ASSETS_PATH}shader/gradation.frag`
    );
  };

  const resize = () => {
    if (Util.isPC()) {
      p.resizeCanvas(window.innerWidth / 2, window.innerHeight / 2, false);
    } else {
      p.resizeCanvas(window.innerWidth / 2, screen.availHeight / 2, false);
    }
  };

  p.setup = () => {
    if (typeof window !== "undefined") {
      if (Util.isPC()) {
        canvas = p.createCanvas(window.innerWidth / 2, window.innerHeight / 2);
      } else {
        canvas = p.createCanvas(window.innerWidth / 2, screen.availHeight / 2);
      }
      window.addEventListener("resize", resize);
      canvas.parent("bg");
      p.frameRate(frameRateVal);
      bg = new Background(background, shaders);
      bg.setup();
      setTimeout(() => {
        document.body.classList.add("is-loaded");
      }, 100);
    }
  };

  p.draw = () => {
    document.body.style.background = "#fff";
    p.background(255, 255, 0);
    p.noErase();
    bg.draw();
    p.image(background, 0, 0, p.width, screen.availHeight / 2);
    p.erase();
    eye.display();
  };

  p.drawOpenEye = (duration, position, width, cb: () => void = () => {}) => {
    eye.updateValue(duration, position, width);
    eye.openEye(cb);
  };

  p.drawCloseEye = (cb: () => void = () => {}) => {
    eye.closeEye(cb);
  };

  p.stopAnimation = () => {
    p.noLoop();
  };

  p.restartAnimation = () => {
    p.loop();
  };

  p.isOpen = () => {
    return eye.getCloseParams();
  };

  p.destroy = () => {
    window.removeEventListener("resize", resize);
    eye.destroy();
  };
};

export default defaultAnimation;
